import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgStorm = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#00C5F2"
      fillRule="evenodd"
      d="M24.27 11.25h3.86A6.88 6.88 0 0 1 35 18.12 6.88 6.88 0 0 1 28.13 25H15a10.001 10.001 0 1 1 9.27-13.75"
      clipRule="evenodd"
    />
    <path
      fill="#85E3F9"
      fillRule="evenodd"
      d="M21.19 33a2 2 0 0 0 2-2c0-.74-.66-2.07-2-4q-2 2.89-2 4a2 2 0 0 0 2 2M15.64 33a2 2 0 0 0 2-2c0-.74-.67-2.07-2-4q-2 2.89-2 4a2 2 0 0 0 2 2M29.68 15.67l-6.91 10.37h5.32v6.86L35 22.62h-5.32z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M7.996 15.7a2.84 2.84 0 0 1 2.874 2.839A2.37 2.37 0 0 1 8.5 20.92a2 2 0 0 1-2-2h1a1 1 0 0 0 1 1 1.37 1.37 0 0 0 1.37-1.377v-.003a1.84 1.84 0 0 0-1.863-1.84h-.005a2.43 2.43 0 0 0-2.422 2.43v.001a3.15 3.15 0 0 0 3.15 3.159h10.1v1H8.73a4.15 4.15 0 0 1-4.15-4.161l.5.001h-.5v-.001A3.43 3.43 0 0 1 7.996 15.7m0 0h-.002l.006.5-.002-.5zm2.874 2.839v.001h-.5l.5-.003zM8.8 24.33h7.82v1H8.804A1.33 1.33 0 0 0 7.5 26.66a.96.96 0 0 0 .947.96l-.014 1A1.96 1.96 0 0 1 6.5 26.66m2.3-2.33h-.008zm-.008 0a2.33 2.33 0 0 0-1.623.696zm-1.623.696A2.33 2.33 0 0 0 6.5 26.66z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgStorm);

export default ForwardRef;
